export default __webpack_public_path__ + "static/media/adminEmployeeActive.d518e91c.svg";